import { PESharedDocumentActions, PESharedDocumentGetters, PESharedDocumentMutations } from './pe-shared-documents'
import { PESharedPhotoActions, PESharedPhotoGetters, PESharedPhotoMutations } from './pe-shared-photo'
import { PESharedQuickEditActions, PESharedQuickEditGetters, PESharedQuickEditMutations } from './pe-shared-quick-edit'

export const PESharedActions = {
  ...PESharedDocumentActions,
  ...PESharedPhotoActions,
  ...PESharedQuickEditActions,
}
export const PESharedGetters = {
  ...PESharedDocumentGetters,
  ...PESharedPhotoGetters,
  ...PESharedQuickEditGetters,
}
export const PESharedMutations = {
  ...PESharedDocumentMutations,
  ...PESharedPhotoMutations,
  ...PESharedQuickEditMutations,
}
